'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeal$002dCourse from "./mealorama.-Meal-Course.js";
var $p;
/** @constructor */
function $c_Lmealorama_MealCourse$$anon$6() {
  this.k0 = null;
  this.g6 = null;
  $j_mealorama$002e$002dMeal$002dCourse.$ct_Lmealorama_MealCourse__T__T__(this, "mainCourse", "Main Course");
}
export { $c_Lmealorama_MealCourse$$anon$6 as $c_Lmealorama_MealCourse$$anon$6 };
$p = $c_Lmealorama_MealCourse$$anon$6.prototype = new $j_mealorama$002e$002dMeal$002dCourse.$h_Lmealorama_MealCourse();
$p.constructor = $c_Lmealorama_MealCourse$$anon$6;
/** @constructor */
function $h_Lmealorama_MealCourse$$anon$6() {
}
export { $h_Lmealorama_MealCourse$$anon$6 as $h_Lmealorama_MealCourse$$anon$6 };
$h_Lmealorama_MealCourse$$anon$6.prototype = $p;
$p.q = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.r = (function() {
  return "mainCourse";
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("mainCourse");
});
var $d_Lmealorama_MealCourse$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MealCourse$$anon$6, "mealorama.MealCourse$$anon$6", ({
  G9: 1,
  as: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  n: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_MealCourse$$anon$6 as $d_Lmealorama_MealCourse$$anon$6 };
//# sourceMappingURL=mealorama.-Meal-Course$$anon$6.js.map
